import { useBetslipContext } from '@/features/betslip/contexts/betslip-context';
import { ParlayTicketModel, TicketModel } from '@/hooks/query';
import { useBetslipStore } from '@/store/betslip';
import { useTranslations } from 'next-intl';

import clsx from 'clsx';
import { betslipStyle } from '@/features/betslip/betslip.style';

interface QuickStakeProps {
	isParlay: boolean;
	ticketKey: string;
	ticketStake: number;
	ticketMaxBet: number;
}

export const plusStake = (value: number, ticketMaxBet: number, ticketStake?: number): number => {
	let newStake = (ticketStake ?? 0) + value;

	newStake = newStake > ticketMaxBet ? ticketMaxBet : newStake;

	return newStake;
}

export const QuickStake = ({
	isParlay,
	ticketKey,
	ticketStake,
	ticketMaxBet
}: QuickStakeProps) => {
	const t = useTranslations('General');

	const { oddsType, quickStake } = useBetslipContext();

	const isUseDefaultQuickStake = quickStake?.startsWith('1');

	const [
		selectAllOddsKey,
		setSelectAllOddsKey,
		setMultiStakePerBet,
		setParlayStakePerBet,
		getTicketByKey,
		updateTicket,
		isBookingBet
	] = useBetslipStore(state => [
		state.selectAllOddsKey,
		state.setSelectAllOddsKey,
		state.setMultiStakePerBet,
		state.setParlayStakePerBet,
		state.getTicketByKey,
		state.updateTicket,
		state.isBookingBet
	]);

	let quickStakeSettings = new Array<string>();

	if (isUseDefaultQuickStake) {
		if (isParlay) {
			quickStakeSettings = ['1', '10', '100'];
		} else {
			const { minBet } = (getTicketByKey(ticketKey, isParlay) as TicketModel);

			quickStakeSettings = [
				(minBet * 2).toString(),
				(minBet * 5).toString(),
				(minBet * 10).toString()
			];
		}
	} else {
		quickStakeSettings = quickStake.split(':').
			filter((value, index) => index != 0).
			reverse();
	}

	const isSelectAll = selectAllOddsKey === ticketKey;

	const resetStakePerBet = (ticket: TicketModel | ParlayTicketModel) => {
		if (isParlay) {
			if ((ticket as ParlayTicketModel).isComboParlay) {
				setParlayStakePerBet(0);
			}
		} else {
			setMultiStakePerBet(0);
		}
	}

	const onNumberPress = (setting: string) => {
		const value = Number(setting);

		let newTicket;
		const ticket = getTicketByKey(ticketKey, isParlay);

		if (isSelectAll) {
			newTicket = { ...ticket, stake: value };
		} else {
			const newStake = plusStake(value, ticketMaxBet, ticketStake);
			newTicket = { ...ticket, stake: newStake };
		}

		setSelectAllOddsKey('');
		resetStakePerBet(newTicket as TicketModel | ParlayTicketModel);
		updateTicket(newTicket as TicketModel | ParlayTicketModel, isParlay, oddsType);
	}

	const onMaxPress = () => {
		const ticket = getTicketByKey(ticketKey, isParlay);
		const newTicket = { ...ticket, stake: ticketMaxBet };

		setSelectAllOddsKey('');
		resetStakePerBet(newTicket as TicketModel | ParlayTicketModel);
		updateTicket(newTicket as TicketModel | ParlayTicketModel, isParlay, oddsType);
	}

	return (
		<div className="bet-slip__quick-stake">
			<div className="quick-stake">
				{
					//settings為字串陣列, 沒有可供識別為key的property, 且每次更新不會有相同的dom可保存, 因此才用index當key
					quickStakeSettings?.map((setting, index) => {
						return (
							<button
								key={index}
								className={clsx(
									'btn',
									betslipStyle.quickStakeButton,
									{ [betslipStyle.bookedQuickStakeButton]: isBookingBet }
								)}
								onClick={() => onNumberPress(setting)}
							>
								<span className="btn__text">+{setting}</span>
							</button>
						)
					})
				}
				<button
					className={clsx(
						'btn',
						betslipStyle.quickStakeButton,
						{ [betslipStyle.bookedQuickStakeButton]: isBookingBet }
					)}
					onClick={onMaxPress}
				>
					<span className="btn__text">{t('lbl_maxbet')}</span>
				</button>
			</div>
		</div>
	);
};